<script setup lang="ts">
const licence = useLicenceStore()
const productContent = useProductContentStore()
const licenceData = computed(() => licence.licenceData)
const { dataAssigned: licenceAssigned } = useDataWatch(licenceData)

const nextArticle = computed(() => productContent.nextArticle)

const nextSubject = computed(() => productContent.nextSubject)

const personalization = usePersonalizationStore()

const router = useRouter()
const handleNextArticleClick = async () => {
  if (nextArticle.value?.id && nextArticle.value?.frontendHref) {
    personalization.addArticleToReadHistory(
      nextArticle.value.id,
      true,
    )
    await router.push(nextArticle.value.frontendHref)
  }
}
</script>

<template>
  <footer
    v-if="!productContent.hydrationInProgress"
    class="flex w-full items-center justify-center bg-[--theme-darkest] py-5 text-white"
  >
    <div class="w-[90%] max-w-[90em]">
      <div
        class="flex items-center justify-end md:mx-[3.1em]"
        :class="{ 'md:justify-between': nextArticle?.id }"
      >
        <div class="flex items-center gap-4">
          <UButtonNew
            v-if="nextArticle?.id"
            pill
            theme="light"
            @click="handleNextArticleClick"
          >
            <template #prepend>
              <u-icon name="arrow-down" />
            </template>
            Neste
          </UButtonNew>
          <span
            class="hidden h-fit w-96 items-center truncate whitespace-nowrap text-button-medium-button-text-regular lg:inline"
          >
            {{ nextArticle?.title }}</span
          >
        </div>
      </div>
    </div>
    <UMarketingBanner v-if="nextArticle?.restricted" />
    <div class="pb-safe"></div>
  </footer>
</template>
